import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65cb9eef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = { class: "content_list" }
const _hoisted_3 = { class: "content_list_item" }
const _hoisted_4 = { class: "content_list_item_top" }
const _hoisted_5 = { class: "content_list_item_top_left" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "content_list_item_top_left_tag"
}
const _hoisted_8 = {
  key: 2,
  class: "content_list_item_top_left_type"
}
const _hoisted_9 = {
  key: 3,
  class: "content_list_item_top_left_type dangerous"
}
const _hoisted_10 = {
  key: 4,
  class: "content_list_item_top_left_type warning"
}
const _hoisted_11 = { class: "content_list_item_top_right" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { key: 5 }
const _hoisted_18 = { key: 6 }
const _hoisted_19 = { key: 7 }
const _hoisted_20 = { key: 8 }
const _hoisted_21 = { class: "content_list_item_content" }
const _hoisted_22 = { class: "content_list_item_content_item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "工序名称：", -1))
const _hoisted_24 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_25 = { class: "content_list_item_content_item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划数量：", -1))
const _hoisted_27 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_28 = { class: "content_list_item_content_item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划日期：", -1))
const _hoisted_30 = { class: "content_list_item_content_item_nr" }
const _hoisted_31 = { class: "content_list_item_content_item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "生产批次：", -1))
const _hoisted_33 = { class: "content_list_item_content_item_nr" }
const _hoisted_34 = { class: "content_list_item_content_item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "发布日期：", -1))
const _hoisted_36 = { class: "content_list_item_content_item_nr" }
const _hoisted_37 = {
  key: 0,
  class: "content_list_item_content_item"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划人员：", -1))
const _hoisted_39 = { class: "content_list_item_content_item_nr" }
const _hoisted_40 = { class: "content_list_item_content_item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "分配数量：", -1))
const _hoisted_42 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_43 = { class: "content_list_item_content_item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "完工数量：", -1))
const _hoisted_45 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_46 = { class: "details_timeline_header" }
const _hoisted_47 = { class: "details_timeline_header_code" }
const _hoisted_48 = {
  key: 0,
  class: "yellow"
}
const _hoisted_49 = {
  key: 1,
  class: "green"
}
const _hoisted_50 = { key: 2 }
const _hoisted_51 = {
  key: 3,
  class: "purple"
}
const _hoisted_52 = { key: 4 }
const _hoisted_53 = { key: 5 }
const _hoisted_54 = { key: 6 }
const _hoisted_55 = {
  key: 0,
  class: "details_timeline_item"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activedian" }, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dian active" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x" }, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_timeline_item_zw" }, null, -1))
const _hoisted_60 = { class: "details_timeline_item_left" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "active_font" }, "产出", -1))
const _hoisted_62 = { class: "details_timeline_item_right" }
const _hoisted_63 = { class: "item" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "物料：", -1))
const _hoisted_65 = { class: "item_nr" }
const _hoisted_66 = {
  key: 0,
  class: "item_nr_item"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "success" }, "[合格品]", -1))
const _hoisted_68 = {
  key: 1,
  class: "item_nr_item"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning" }, "[不良品]", -1))
const _hoisted_70 = {
  key: 1,
  class: "details_timeline_item"
}
const _hoisted_71 = {
  key: 0,
  class: "activedian"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_timeline_item_zw" }, null, -1))
const _hoisted_73 = { class: "details_timeline_item_left" }
const _hoisted_74 = { class: "details_timeline_item_right" }
const _hoisted_75 = { class: "item" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "物料：", -1))
const _hoisted_77 = {
  key: 0,
  class: "item_nr"
}
const _hoisted_78 = { style: {"margin":"0"} }
const _hoisted_79 = { class: "details_timeline_item" }
const _hoisted_80 = {
  key: 0,
  class: "activedian"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details_timeline_item_zw" }, null, -1))
const _hoisted_82 = { class: "details_timeline_item_left" }
const _hoisted_83 = { class: "details_timeline_item_right" }
const _hoisted_84 = { class: "item" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "分配数量：", -1))
const _hoisted_86 = { class: "item_nr" }

import { ref, onMounted, watch } from 'vue'
    import { useRoute, useRouter } from "vue-router"
    import { queryByID } from '@/apis/PlanningAPI'
    import NotFound from '@/components/common/NotFound.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    // 详情数据
    let info:any = ref({})

    let loading = ref<boolean>(true)

    // 获取详情
    const queryByIDs = () => {
        queryByID(route.query.id)
            .then(res => {
                if (res.code === 200) {
                    info.value = res.data
                }
            })
    }

    const toJump = () => {
        router.push({ name: 'reportingForWork' })
    }

    const jump = (item: any) => {
        if (item.status === 4 || item.status === 6 || item.paused === 1) {
            router.push({ name: 'afterWorkReport', query: { id: item.id } })
        } else {
            router.push({ name: 'workOrderReporting', query: { id: item.id } })
        }
        // router.push({ name: 'workOrderReporting', query: { id } })
    }

    const proUserStr = (item: any) => {
        if (!item.proUserList || item.proUserList.length<1) {
            return '-'
        }
        return item.proUserList.map((user: any) => { return user.proUserDepartName }).join('，')
    }

    onMounted(() => {
        queryByIDs()
    })

    watch(() => info.value, (news) => {
        if (JSON.stringify(news) !== "{}") {
            loading.value = false
        }
    }, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_van_skeleton = _resolveComponent("van-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_skeleton, {
        loading: _unref(loading),
        title: "",
        row: 3,
        "row-width": ['100%', '100%', '100%', '100%']
      }, null, 8, ["loading"]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(info).mmodel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(info).mmodel.name), 1))
              : _createCommentVNode("", true),
            (_unref(info).urgent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "优先" + _toDisplayString(_unref(info).urgent), 1))
              : _createCommentVNode("", true),
            (_unref(info).type === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "正常"))
              : (_unref(info).type === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "异常"))
                : (_unref(info).type === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "返工"))
                  : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_unref(info).status === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "已生成"))
              : _createCommentVNode("", true),
            (_unref(info).status === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "已发布"))
              : _createCommentVNode("", true),
            (_unref(info).status === 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "已撤回"))
              : _createCommentVNode("", true),
            (_unref(info).status === 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "已取消"))
              : _createCommentVNode("", true),
            (_unref(info).status === 4)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "已分配"))
              : _createCommentVNode("", true),
            (_unref(info).status === 5)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "已暂停"))
              : _createCommentVNode("", true),
            (_unref(info).status === 6)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "已完工"))
              : _createCommentVNode("", true),
            (_unref(info).status === 7)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已入库"))
              : _createCommentVNode("", true),
            (_unref(info).status === 8)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "已关闭"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            (_unref(info).pmodel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(info).pmodel.name), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            (_unref(info).umodel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(info).num) + _toDisplayString(_unref(info).umodel.name), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(info).planDate), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(info).batch), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(info).createTime), 1)
          ]),
          (_unref(info).usermodel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(info).usermodel.realname), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            (_unref(info).umodel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_unref(info).distributNum) + _toDisplayString(_unref(info).umodel.name), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            (_unref(info).umodel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(info).doneNum) + _toDisplayString(_unref(info).umodel.name), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_unref(loading)]
      ])
    ]),
    (_unref(info).workorderList && _unref(info).workorderList.length === 0)
      ? (_openBlock(), _createBlock(NotFound, {
          key: 0,
          info: "暂未分配工单"
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(info).workorderList, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "details_timeline",
            key: i
          }, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("span", null, "工单编号：" + _toDisplayString(item.code), 1),
                _createElementVNode("span", null, "生产人员：" + _toDisplayString(proUserStr(item)), 1)
              ]),
              (item.status === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_48, "已创建"))
                : _createCommentVNode("", true),
              (item.status === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, "已备料"))
                : _createCommentVNode("", true),
              (item.status === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "已完工"))
                : _createCommentVNode("", true),
              (item.status === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_51, "已检验"))
                : _createCommentVNode("", true),
              (item.status === 4)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, "已报工"))
                : _createCommentVNode("", true),
              (item.status === 5)
                ? (_openBlock(), _createElementBlock("span", _hoisted_53, "已入库"))
                : _createCommentVNode("", true),
              (item.status === 6)
                ? (_openBlock(), _createElementBlock("span", _hoisted_54, "已取消"))
                : _createCommentVNode("", true)
            ]),
            (item.produceDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _hoisted_56,
                  _hoisted_57,
                  _hoisted_58,
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("span", null, _toDisplayString(item.produceDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        (item.qualifiedNum !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("span", null, _toDisplayString(item.qualifiedNum) + _toDisplayString(_unref(info).umodel.name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.unqualifiedNum !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                              _hoisted_69,
                              _createElementVNode("span", null, _toDisplayString(item.unqualifiedNum) + _toDisplayString(_unref(info).umodel.name), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.materialDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  (!item.produceDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["dian", { 'active': !item.produceDate }])
                  }, null, 2),
                  _createElementVNode("div", {
                    class: "x",
                    style: _normalizeStyle({ height: item.materialList.length === 1 ? '2.1rem' :  1.2 * item.materialList.length + 'rem' })
                  }, null, 4),
                  _hoisted_72,
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("span", {
                      class: _normalizeClass({'active_font': !item.produceDate})
                    }, "投料", 2),
                    _createElementVNode("span", null, _toDisplayString(item.materialDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      (item.materialList && item.materialList.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.materialList, (items, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "item_nr_item",
                                key: idx
                              }, [
                                _createElementVNode("span", _hoisted_78, _toDisplayString(items.name) + " / " + _toDisplayString(items.num) + _toDisplayString(items.unitName), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_79, [
              (!item.materialDate && !item.produceDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["dian", { 'active': !item.materialDate && !item.produceDate }])
              }, null, 2),
              _hoisted_81,
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("span", {
                  class: _normalizeClass({'active_font': !item.materialDate && !item.produceDate})
                }, "分配", 2),
                _createElementVNode("span", null, _toDisplayString(item.distributeDate), 1)
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _hoisted_85,
                  _createElementVNode("div", _hoisted_86, _toDisplayString(item.planNum) + _toDisplayString(_unref(info).umodel.name), 1)
                ])
              ])
            ])
          ]))
        }), 128))
  ]))
}
}

})